import { Teacher } from "./userMock";

export type TeacherPostPayload = Teacher & {
  school_id: number;
};

export const teacherPostPayloadMock: TeacherPostPayload = {
  id: 32,
  pk: 32,
  unique_id: "487df0dc14f14241bfcc47d1ff0a8109",
  user_id: 216,
  user_pk: 216,
  role: "teacher",
  secondary_role: null,
  validation_state: "valid",
  subjects: ["Science"],
  lowest_preferred_grade_level: 2,
  highest_preferred_grade_level: 12,
  has_added_students_this_year: false,
  has_created_assignment_this_year: false,
  school: {
    id: 2000287762,
    pk: 2000287762,
    unique_id: "d6d20da631c04ca18b67468569353e0d",
    email_domains: [],
    customer_email_domains: [],
    is_valid: true,
    name: "francisco.solano Premium District High School",
    nces_school_id: null,
    nces_district_id: null,
    address: {
      id: 2000325256,
      address1: "084 Christopher Corners Apt. 364",
      address2: "",
      address3: "",
      city: "Port Debra",
      state: "NY",
      country: "US",
      zip_code: "50257",
      attn: "",
      timezone: null,
    },
  },
  schools: [
    {
      id: 2000287762,
      pk: 2000287762,
      unique_id: "d6d20da631c04ca18b67468569353e0d",
      email_domains: [],
      customer_email_domains: [],
      is_valid: true,
      name: "francisco.solano Premium District High School",
      nces_school_id: null,
      nces_district_id: null,
      address: {
        id: 2000325256,
        address1: "084 Christopher Corners Apt. 364",
        address2: "",
        address3: "",
        city: "Port Debra",
        state: "NY",
        country: "US",
        zip_code: "50257",
        attn: "",
        timezone: null,
      },
    },
  ],
  school_id: 2000287762,
};
